// src/components/Layout.js
import React from 'react';
import { AppBar, Toolbar, Typography, Container, Box, Paper, BottomNavigation, BottomNavigationAction } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import ListAltIcon from '@mui/icons-material/ListAlt';
import PersonIcon from '@mui/icons-material/Person';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import QrCodeIcon from '@mui/icons-material/QrCode';

function Layout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = React.useState(() => {
    if (location.pathname === '/' || location.pathname === '') return 'home';
    if (location.pathname.startsWith('/transactions')) return 'transactions';
    if (location.pathname.startsWith('/profile')) return 'profile';
    if (location.pathname.startsWith('/scan')) return 'scan';
    if (location.pathname.startsWith('/qr')) return 'qr';
    return 'home';
  });

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(`/${newValue}`);
  };

  return (
    <Box sx={{ pb: 7 }}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6">Pi QR Payment App</Typography>
        </Toolbar>
      </AppBar>
      <Container sx={{ mt: 4 }}>{children}</Container>
      <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
        <BottomNavigation value={value} onChange={handleChange}>
          <BottomNavigationAction label="Home" value="home" icon={<HomeIcon />} />
          <BottomNavigationAction label="Transactions" value="transactions" icon={<ListAltIcon />} />
          <BottomNavigationAction label="Profile" value="profile" icon={<PersonIcon />} />
          <BottomNavigationAction label="Scan" value="scan" icon={<QrCodeScannerIcon />} />
          <BottomNavigationAction label="QR" value="qr" icon={<QrCodeIcon />} />
        </BottomNavigation>
      </Paper>
    </Box>
  );
}

export default Layout;
